import { render, staticRenderFns } from "./Pdf3.vue?vue&type=template&id=2b324316&scoped=true&"
import script from "./Pdf3.vue?vue&type=script&lang=js&"
export * from "./Pdf3.vue?vue&type=script&lang=js&"
import style0 from "./Pdf3.vue?vue&type=style&index=0&id=2b324316&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b324316",
  null
  
)

export default component.exports